"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../utils/api");
var myList_1 = __importDefault(require("./queries/myList"));
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
var config_1 = __importStar(require("../../config"));
// eslint-disable-next-line import/prefer-default-export
exports.fetchMyList = function () {
    return api_1.createApiAction(constants_1.FETCH_MY_LIST, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: myList_1.default,
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.setDeviceVideoQuality = function (accountId, videoQuality) {
    return toolkit_1.createAction(constants_1.SET_DEVICE_VIDEO_QUALITY)({ accountId: accountId, videoQuality: videoQuality });
};
//# sourceMappingURL=actions.js.map